export const handleDispatchValue = (dispatch, action, value) => {
  dispatch(action(value));
};
